/**
* @Author: glb
* @Description: 商品编号、名称等自动完成组件，searchType:'goodsCode'-商品编号  'goodsName'-商品名称  'barcode'-商品条码
* @DateTime: Created in 14:30 2017/12/29
*/
<template>
	<div>
		<AutoCompleteCustom
				:disabled="disabled"
				:autofocus="autofocus"
				@on-select="onSelect"
				:defalutOpen="defalutOpen"
				:transfer="transfer"
				:value="value"
				@input="onChange"
				:dataSource="dataSource"
				@on-search="search"
				:loading="loading"
				:size="size"
				@on-focus="inputFocus"
				@click-outside="clickOutside"
				:placeholder="placeholderDefault">
		</AutoCompleteCustom>
	</div>
</template>
<script type="text/ecmascript-6">
import AutoCompleteCustom from 'src/components/common/autoCompleteCustom/autoCompleteCustom.vue'
import {InterObj} from 'utils/serviceConst'
// import requestMethods from 'api/config'
export default {
    name: 'formAutoSearch',
    components: {AutoCompleteCustom},
    props: {
        disabled: {
            default: false
        },
        autofocus: {type: Boolean, default: false},
        value: {
            default: ''
        },
        size: {
            type: String,
            default: 'small'
        },
        placeholder: {
            type: String,
        },
        searchType: {
            type: String,
            default: 'goodsCode',
            required: true
        },
        autoBarcode: {
            type: String,
            default: ''
        },
        transfer: {
            type: Boolean,
            default: false
        },
        searchParams: {
            type: Object,
            default: () => {
                return {}
            }
        },
        defalutOpen: {
            default: false
        }
    },
    data() {
        return {
            dataSource: [],
            autoBarcodeObj: {},
            autoNameObj: {},
            loading: false
        }
    },
    computed: {
        placeholderDefault() {
            if (this.placeholder || this.placeholder === '') {
                return this.placeholder
            } else {
                let name = ''
                switch (this.searchType) {
                    case 'goodsCode':
                    case 'codeAndBarcode':
                        name = '商品编号'
                        break
                    case 'goodsName':
                        name = '商品名称'
                        break
                    case 'barcode':
                        name = '商品条码'
                        break
                    case 'storehouseStockCode':
                        name = '库位'
                        break
                    case 'externalCodeIncome':
                    case 'externalCodeOutcome':
                        //	出入库客户单号， 名称一致接口不一样
                        name = '客户单号'
                        break
                    case 'inField1':
                    case 'outField1':
                        name = '自定义字段1'
                        break
                    case 'inField2':
                    case 'outField2':
                        name = '自定义字段2'
                        break
                    case 'inField3':
                    case 'outField3':
                        name = '自定义字段3'
                        break
                    case 'outAddress':
                        name = '收货地址'
                        break
                    case 'supplier':
                        name = '供应商名称'
                        break
                    default:
                        break
                }
                return `请输入${name}`
            }
        }
    },
    methods: {
        clickOutside() {
            this.$emit('click-outside')
        },
        inputFocus(){
            this.$emit('on-focus')
        },
        onSelect(v) {
            this.$emit('on-select', v)
        },
        onChange(v) {
            this.$emit('input', v)
            if (this.searchType === 'codeAndBarcode') {
                let autoBarcode = this.autoBarcodeObj.hasOwnProperty(v) ? this.autoBarcodeObj[v] : ''
                let autoName = this.autoNameObj.hasOwnProperty(v) ? this.autoNameObj[v] : ''
                if (autoBarcode && autoName) {
                    this.$emit('updateBarcode', autoBarcode)
                    this.$emit('updateName', autoName)
                }
            }
        },
        async search(value) {
            if (this.timeOut) {
                clearTimeout(this.timeOut)
            }
            this.timeOut = setTimeout(async () => {
                this.loading = true
                let data
                let autoBarcodeObj = this.autoBarcodeObj
                let autoNameObj = this.autoNameObj
                switch (this.searchType) {
                    case 'codeAndBarcode':
                        data = await this.searchCodeAndBarcode(value)
                        break
                    case 'goodsCode':
                        data = await this.searchGoodsCode(value)
                        break
                    case 'goodsName':
                        data = await this.searchGoodsName(value)
                        break
                    case 'storehouseStockCode':
                        data = await this.searchStorehouseStockCode(value)
                        break
                    case 'barcode':
                        data = await this.searchBarcode(value)
                        break
                    case 'supplier':
                        let arr = []
                        let odata
                        odata = await this.searchSupplier(value)
                        if (odata.data !== '') {
                            odata.data.forEach(function(item) {
                                arr.push(item.name)
                            })
                        }
                        data = {data: arr}
                        break
                    case 'externalCodeIncome':
                        data = await this.searchExternalCodeIn(value)
						break
                    case 'externalCodeOutcome':
                        //	出入库客户单号， 名称一致接口不一样
                        data = await this.searchExternalCodeOut(value)
                        break
                    case 'inField1':
                        data = await this.searchInField(value, 'field1')
                        break
                    case 'inField2':
                        data = await this.searchInField(value, 'field2')
                        break
                    case 'inField3':
                        data = await this.searchInField(value, 'field3')
                        break
                    case 'outField1':
                        data = await this.searchOutField(value, 'field1')
                        break
                    case 'outField2':
                        data = await this.searchOutField(value, 'field2')
                        break
                    case 'outField3':
                        data = await this.searchOutField(value, 'field3')
                        break
                    case 'outAddress':
                        data = await this.searchOutAddress(value)
                        break
                    default:
                        break
                }
                this.loading = false
                if (this.searchType === 'codeAndBarcode') {
                    let dataArray = data.data || []
                    this.dataSource = []
                    if (dataArray.length) {
                        dataArray.forEach(item => {
                            let codeValue = item['code']
                            this.dataSource.push(codeValue)
                            autoBarcodeObj[codeValue] = item['barcode']
                            autoNameObj[codeValue] = item['name']
                        })
                    }
                } else {
                    this.dataSource = data.data || []
                }
            }, 200)
        },
        searchCodeAndBarcode(value) {
            return requestMethods.get(InterObj.selectGoodsCodeAndBarcodeListByCodeAndOwner, {
                code: value,
                recordCount: 10,
                ...this.searchParams
            })
        },
        searchGoodsCode(value) {
            return requestMethods.get(InterObj.selectGoodsCodeListByCodeAndOwner, {
                goodsExtCode: value,
                recordCount: 10,
                ...this.searchParams
            })
        },
        searchGoodsName(value) {
            return requestMethods.get(InterObj.selectGoodsCodeListByCodeAndOwner, {
                name: value,
                recordCount: 10,
                ...this.searchParams
            })
        },
        searchBarcode(value) {
            return requestMethods.get(InterObj.selectGoodsCodeListByCodeAndOwner, {
                barcode: value,
                recordCount: 10,
                ...this.searchParams
            })
        },
        searchSupplier(value) {
            return requestMethods.get(InterObj.queryDistributor, {
                type: 1,
                name: value,
                pageSize: 10,
                page: 1,
                ...this.searchParams
            })
        },
        searchStorehouseStockCode(value) {
            return requestMethods.get(InterObj.selectCodeListByVague, {
                code: value,
                recordCount: 10,
                ...this.searchParams
            })
        },
        searchExternalCodeIn(value) {
            return requestMethods.get(InterObj.searchExternalCodeIn, {
                externalCode: value
            })
		},
        searchExternalCodeOut(value) {
            return requestMethods.get(InterObj.searchExternalCodeOut, {
                externalCode: value
            })
        },
        searchInField(value, key) {
            let params = {}
            params[key] = value
            return requestMethods.get(InterObj.searchInField, params)
        },
        searchOutField(value, key) {
            let params = {}
            params[key] = value
            return requestMethods.get(InterObj.searchOutField, params)
        },
        searchOutAddress(value) {
            return requestMethods.get(InterObj.searchOutAddress, {
                region: value
            })
        }
    }
}
</script>
